import { Archive } from "lucide-react";

import { useListTeamProducts } from "../../api/generated/endpoints/teams/teams";
import { FilterMenu } from "../../ui/FilterMenu";

export interface ProductFilterProps {
  teamId: string;
  value: string | undefined;
  onChange: (productId: string | undefined) => void;
}

/**
 * Live's Product filter over a gallery (`product-filter`, capture gaps/22): the "Product" chip
 * (`Archive`) and the team's products, every brand's, by name, as live lists them (#388's
 * `listTeamProducts`). The library then holds the files saved from jobs that showed it.
 */
export function ProductFilter({ teamId, value, onChange }: ProductFilterProps) {
  const products = useListTeamProducts(teamId).data ?? [];
  return (
    <FilterMenu
      label="Product"
      icon={<Archive size={16} />}
      options={products.map((product) => ({ value: product.id, label: product.name }))}
      value={value}
      onChange={onChange}
    />
  );
}
